module.exports = __webpack_public_path__ + "static/media/high_heels_desktop.ed2edf27.jpg";